import { API } from './api'

export async function GET_REPORTS() {
	const { data } = await API.get(`api/user/reports`);
	
	return data;
}